<template>
  <!-- 赠片专用loading 开始 -->
  <div class="give_container_loading">
      <div class="loading_con">
          <i class="icon_loading"></i>
          <!-- <div class="loading_text">努力加载中</div> -->
      </div>
  </div>
  <!-- 赠片专用loading loading 结束 -->

</template>

<script>

export default {
  data () {
    return {

    }
  }
}
</script>
<style>
.give_container_loading .icon_loading{width: 2.56rem;height: 4.07rem;margin-top: -3.14rem}
</style>
